import type { Distance, Rectangle } from "@pdfking/math"

import type { OrientationKind } from "#internal"

/**
 * Mirrors Python `orientation_kind.set_orientation(canvas)`
 * (generic.py:138-141):
 *
 *   if same_orientation(self, canvas) or not self.can_set_orientation:
 *       return canvas
 *   return canvas.rotate()
 *
 * Rotate the canvas to the orientation's portrait/landscape preference —
 * unless it already matches, or the orientation is "as-is" (`n`/`nv`,
 * `can_set_orientation=false`) which keeps the canvas exactly as given.
 * To force landscape (Python `enforce_landscape`), pass `LANDSCAPE`.
 */
export const ApplyOrientation = (
  size: Rectangle<Distance>,
  orientation: OrientationKind
): Rectangle<Distance> => {
  if (!orientation.can_set_orientation) return size
  const is_landscape = size.width >= size.height
  if (orientation.is_portrait === !is_landscape) return size
  return { width: size.height, height: size.width }
}
